import http from 'utils/http';
import * as R from 'ramda';
import { formatNumber } from 'utils/helpers/format';

export const capacity = compartments =>
  R.reduce(R.useWith(R.add, [R.identity, R.prop('capacityInGallons')]), 0, compartments);

export const trailerCapacity = compartments =>
  compartments.length ? formatNumber(capacity(compartments)) : '--';

export const compartmentsNumber = compartments =>
  compartments.length ? compartments.length : '--';

export const downloadFile = (trailerId, type, carrier) => {
  const { carrierId, magellanId } = carrier;

  // https://stackoverflow.com/questions/50694881/how-to-download-file-in-react-js
  http
    .get(
      `${process.env.REACT_APP_DISPATCHING_BASE_URL}/compliance/trailer-status/file-download?trailerId=${trailerId}&docType=${type}`,
      {
        headers: {
          'X-CARRIERID': carrierId,
          'X-MAGELLANID': magellanId,
        },
        responseType: 'blob',
      }
    )
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers['x-file-name']);
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
};

export const downloadTemplate = (type, carrier) => {
  const { carrierId, magellanId } = carrier;

  http
    .get(
      `${process.env.REACT_APP_DISPATCHING_BASE_URL}/compliance/trailer-status/template-download?docType=${type}`,
      {
        headers: {
          'X-CARRIERID': carrierId,
          'X-MAGELLANID': magellanId,
        },
        responseType: 'blob',
      }
    )
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers['x-file-name']);
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
};
